module.exports = __webpack_public_path__ + "img/pelvis.3c62f100.png";